import { render, staticRenderFns } from "./Transacoes.vue?vue&type=template&id=34d33a78&"
import script from "./Transacoes.vue?vue&type=script&lang=js&"
export * from "./Transacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports